import React from "react";
import { Box, Button, useTheme, TextField, Stack, Grid } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
// import scssVars from "../../../../../../../scss/variables.module.scss";
import MaterialModal from "../../../app/material-modal";
import { buttonCommonStyle } from "../../../../util/admin/cssCommonStyle";
// import MaterialModal from "../../../../../../components/app/material-modal";
// import { buttonCommonStyle } from "../../../../utils/cssCommonStyle";
const buttonStyle = {
  // color: scssVars.mainIconColor,
  // borderColor: scssVars.borderGrey,
  width: 170,
  marginBottom: 1,
  backgroundColor: "white",
  ":hover": {
    // color: scssVars.mainButtonHighlight,
  },
};
export function AddNewUserModal() {
  const [open, setOpen] = React.useState(false);
  const muiTheme = useTheme();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button variant="outlined" sx={buttonStyle} onClick={handleOpen}>
          <AddCircleIcon
            sx={{
              marginRight: "4px",
              fontSize: "24px",
              color: muiTheme.palette.primary.main,
              opacity: 1,
            }}
          />
          Add New User
        </Button>
      </Box>
      <MaterialModal
        open={open}
        handleDialogClose={handleClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              maxHeight: "400px",
              maxWidth: "500px",
              ".MuiDialogContent-root": {
                overflow: "auto",
              },
            },
          },
        }}
        title="Create User"
      >
        <Box>
          <Stack direction="column" spacing={2} mb={2}>
            <TextField label="Name" id="outlined-size-small" size="small" />
            <TextField
              label="Email Address"
              id="outlined-size-small"
              size="small"
            />
            <TextField
              label="User Name"
              id="outlined-size-small"
              size="small"
            />
          </Stack>

          <Grid
            container
            sx={{
              justifyContent: "flex-end",
              gap: "8px",
            }}
          >
            <Button variant="outlined" size="large" sx={buttonCommonStyle}>
              Create
            </Button>
            <Button variant="outlined" size="large" sx={buttonCommonStyle}>
              Create & Switch
            </Button>
          </Grid>
        </Box>
      </MaterialModal>
    </Box>
  );
}
